import { useLocation } from "react-router-dom";
import {
  Dialog,
  Description,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { VStack } from "../components/utils";

export function generateRedirectUrl() {
  const redirectUrl = encodeURIComponent(window.location.href);
  const baseUrl = (
    process.env.REACT_APP_ID_SERVER_CLIENT_URL ??
    "https://identity.dev.hissa.com"
  ).replace(/\/+$/, "");
  const url = `${baseUrl}/login?redirect=${redirectUrl}&platform=captable`;
  return url;
}

export function checkIsSharedPage() {
  const location = useLocation();
  const path = decodeURIComponent(location.pathname); // Decode special characters like `+`

  const allowedPaths = [
    /^\/share\/?$/, // Matches "/share"
    /^\/share\/[^/]+\/?$/, // Matches "/share/:id" with optional trailing slash
    /^\/share\/login\/[^/]+$/, // Matches "/share/login/:id"
    /^\/share\/login\/[^/]+\/[^/]+\/?$/, // Matches "/share/login/:id/:email/"
    /^\/share\/login\/[^/]+\/[^/]+\/[^/]+$/, // Matches "/share/login/:id/:email/:otp"

    // Inv paths
    /^\/inv\/captable\/[^/]+\/[^/]+$/, // Matches "/inv/captable/:cId/:token"
    /^\/inv\/finance\/[^/]+\/[^/]+$/, // Matches "/inv/finance/:cId/:token"
    /^\/inv\/rights\/overview\/[^/]+\/[^/]+$/, // Matches "/inv/rights/overview/:cId/:token"
    /^\/inv\/security\/[^/]+\/[^/]+$/, // Matches "/inv/security/:cId/:token"
    /^\/inv\/security\/individual\/[^/]+\/[^/]+\/[^/]+$/, // Matches "/inv/security/individual/:type/:cId/:token"

    // Transaction paths
    /^\/inv\/transaction\/allTransactions\/[^/]+\/[^/]+$/, // Matches "/inv/transaction/allTransactions/:cId/:token"
    /^\/inv\/transaction\/round\/[^/]+\/[^/]+\/[^/]+$/, // Matches "/inv/transaction/round/:id/:cId/:token"
    /^\/inv\/transaction\/exercise\/[^/]+\/[^/]+\/[^/]+$/, // Matches "/inv/transaction/exercise/:id/:cId/:token"
    /^\/inv\/transaction\/buyback\/[^/]+\/[^/]+\/[^/]+$/, // Matches "/inv/transaction/buyback/:id/:cId/:token"
    /^\/inv\/transaction\/secondary\/[^/]+\/[^/]+\/[^/]+$/, // Matches "/inv/transaction/secondary/:id/:cId/:token"
    /^\/inv\/transaction\/bonus\/[^/]+\/[^/]+\/[^/]+$/, // Matches "/inv/transaction/bonus/:id/:cId/:token"
    /^\/inv\/transaction\/split\/[^/]+\/[^/]+\/[^/]+$/, // Matches "/inv/transaction/split/:id/:cId/:token"

    // Company pages
    /^\/inv\/t2Company\/[^/]+\/?$/, // Matches "/inv/t2Company/:cin/"
    /^\/inv\/t2Company\/[^/]+\/[^/]+$/, // Matches "/inv/t2Company/:cin/:token"
    /^\/inv\/t3Company\/[^/]+\/?$/, // Matches "/inv/t3Company/:cin/"
    /^\/inv\/t3Company\/[^/]+\/[^/]+$/, // Matches "/inv/t3Company/:cin/:token"

    // Settings
    /^\/inv\/setting\/boardModule\/[^/]+\/[^/]+$/, // Matches "/inv/setting/boardModule/:cId/:token"
  ];

  // Return true only if the path matches one of the allowed patterns
  return allowedPaths.some((regex) => regex.test(path));
}

export function WarningModal({ open }: { open: boolean }) {
  return (
    <Dialog as="div" className="relative z-50" open={open} onClose={() => {}}>
      <div
        className="fixed inset-0 bg-black bg-opacity-30"
        aria-hidden="true"
      />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="bg-white rounded-lg shadow-xl max-w-sm w-full p-6">
          <VStack className="space-y-4">
            <DialogTitle className="text-danger font-bold text-lg">
              Warning!!!
            </DialogTitle>
            <div className="border-b border-gray-300"></div>
            <Description>
              You have already logged into this Platform on another browser tab.
              Kindly revert to the original login tab or close the other tab to
              proceed.
            </Description>
          </VStack>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
